/* eslint import/prefer-default-export: 0 */

/** The status of the order */
export const OrderStatus = {
  /** Canceled */
  CANCELLED: "CANCELLED",
  /** Fulfilled, delivered / picked-up */
  FULFILLED: "FULFILLED",
  /** Initiated, created */
  INITIATED: "INITIATED",
  /** Not fulfilled, not delivered / not picked-up, expired */
  NOT_FULFILLED: "NOT_FULFILLED",
  /** Preparing */
  PREPARING: "PREPARING",
  /** Ready, to deliver / to pick-up */
  READY: "READY",
  /** To prepare */
  TO_PREPARE: "TO_PREPARE",
};

export const OrderPickUpMode = {
  /** Delivery only */
  DELIVERY_ONLY: "DELIVERY_ONLY",
  /** Delivery or pick-up */
  DELIVERY_OR_PICK_UP: "DELIVERY_OR_PICK_UP",
  /** None (mainly for services) */
  NONE: "NONE",
  /** Pick-up only */
  PICK_UP_ONLY: "PICK_UP_ONLY",
};

export const OrderPaymentMode = {
  /** Pay with cashless balance (of wallet). Customer must be logged in then. */
  CASHLESS: "CASHLESS",
  /** Pay at pick-up or delivery. So the customer skip the payment step on the widget. */
  OFFLINE: "OFFLINE",
  /** Pay thanks to a bank card or any other payment method available. */
  ONLINE: "ONLINE",
};
